<template>
  <section id="promozioni" class="promotions">
    <div class="container">
      <div class="section-title" data-aos="fade-up">
        <h2>Promozioni</h2>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-5 mb-lg-0" data-aos="fade-right">
          <ul class="nav nav-tabs flex-column">
            <li v-for="(promotion, index) in promotions" :key="index" class="nav-item">
              <promotion-card v-on:click="cardClicked(index)" :title="promotion.title" :cardIndex="index" :isActive="index === 0" :image="promotion.coupon" :fileName="promotion.image">
                <p><span v-html="promotion.text"></span></p>
              </promotion-card>
            </li>
          </ul>
        </div>

        <div class="col-lg-7 ml-auto" data-aos="fade-left">
          <div class="tab-content">
            <promotion-image v-for="(promotion, index) in promotions" :key="promotion.title" :cardIndex="index" :image="promotion.image" :isActive="index == 0">
              <span v-html="promotion.caption"></span>
            </promotion-image>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PromotionCard from "./PromotionCard.vue";
import PromotionImage from "./PromotionImage.vue";
import axios from "axios";
import * as $ from "jquery";
import Constants from "../common.js";


export default {
  data () {
    return {
      promotions: [],
    };
  },
  mounted () {
    axios
      .get(Constants.PROMOTION_FILE)
      .then((response) => {
        this.promotions = response.data;
      })
      .then(() => {
        $(".promotions .nav-link button").hide();
        $(".promotions .nav-link.active button").show();
      });
  },
  methods: {
    cardClicked (index) {
      $(".promotions .nav-link button").hide();
      $("#promotionCardButton" + index).show();
    },
  },
  components: {
    PromotionCard,
    PromotionImage,
  },
};
</script>

<style>
/* .promotions .featureImage {
  text-align: center;
}

.promotions .featureImage img {
  max-width: 75%;
}

.promotions .featureImage figcaption {
  font-size: 12px;
  margin-bottom: 0;
  margin-top: 1%;
  text-align: left;
} */

.promotions .nav-tabs {
  border: 0;
}

.promotions .nav-link {
  display: flex;
  flex-direction: column;
  border: 0;
  padding: 20px;
  transition: 0.3s;
  color: #21413c;
}

.promotions .nav-link button {
  padding: 0;
  align-self: flex-end;
}

.promotions .nav-link:hover {
  /*color: #1bac91;*/
  box-shadow: 0px 2px 15px rgb(0 0 0 / 12%)
}

.promotions .nav-link h4 {
  font-size: 18px;
  font-weight: 600;
}

.promotions .nav-link p {
  font-size: 14px;
  margin-bottom: 0;
}

.promotions .nav-link.active {
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.12);
}

.promotions .nav-link.active h4 {
  color: #1bac91;
}

.promotions .tab-pane.active {
  -webkit-animation: slide-down 0.5s ease-out;
  animation: slide-down 0.5s ease-out;
}

.promotions .nav-link.active i:hover,
.promotions .nav-link.active button:hover {
  color: #1bac91;
}

@-webkit-keyframes slide-down {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slide-down {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
